var map = {
	"./tech-responsive-artificial-intelligence.svg": 528,
	"./tech-responsive-chatgpt.svg": 596,
	"./tech-responsive-data.svg": 597,
	"./tech-responsive-excel.svg": 598,
	"./tech-responsive-git.svg": 599,
	"./tech-responsive-google-sheets.svg": 600,
	"./tech-responsive-jupyter.svg": 601,
	"./tech-responsive-langchain.svg": 602,
	"./tech-responsive-multiple.svg": 603,
	"./tech-responsive-powerbi.svg": 604,
	"./tech-responsive-powerpoint.svg": 605,
	"./tech-responsive-python.svg": 606,
	"./tech-responsive-r.svg": 607,
	"./tech-responsive-sql.svg": 608,
	"./tech-responsive-tableau.svg": 609,
	"./tech-responsive-theory.svg": 610
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 520;